import get from "lodash.get";

const getFullAmount = feeDesc => {
  const matches = get(feeDesc, "fullAmount", "").match(/[\d.]/g);
  if (!matches) return 0;
  return parseFloat(matches.join(""), 10);
};

export default getFullAmount;
